import { render, staticRenderFns } from "./OtpPage.vue?vue&type=template&id=8853055a&scoped=true"
import script from "./OtpPage.vue?vue&type=script&lang=js"
export * from "./OtpPage.vue?vue&type=script&lang=js"
import style0 from "./OtpPage.vue?vue&type=style&index=0&id=8853055a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8853055a",
  null
  
)

export default component.exports